// src/app/services/quickRepliesService.ts
//
// Respostas rápidas (canned responses) do chat ao vivo do WhatsApp —
// apps.attendances.QuickReply no eleveia-api. Compartilhadas entre toda a
// equipe da escola, qualquer operador pode criar/editar/remover.

import { api } from './api';
import type { MacroAction } from '../lib/macros';

export interface QuickReply {
  id: number;
  title: string;
  content: string;
  /** Ações feitas depois do envio (macro). Vazio = resposta rápida comum. */
  actions: MacroAction[];
  position: number;
  created_at: string;
  updated_at: string;
}

export interface QuickReplyPayload {
  title: string;
  content: string;
  actions?: MacroAction[];
  position?: number;
}

interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const quickRepliesService = {
  list: async (): Promise<QuickReply[]> => {
    const res = await api.get<PaginatedResponse<QuickReply> | QuickReply[]>('/attendances/quick-replies/');
    return Array.isArray(res) ? res : (res.results ?? []);
  },

  create: (data: QuickReplyPayload): Promise<QuickReply> =>
    api.post('/attendances/quick-replies/', data),

  update: (id: number, data: Partial<QuickReplyPayload>): Promise<QuickReply> =>
    api.patch(`/attendances/quick-replies/${id}/`, data),

  remove: (id: number): Promise<void> =>
    api.delete(`/attendances/quick-replies/${id}/`),
};
